export const appInfo={
    name:'Guardians Collective',
    description:'Protect What You Love',
    title:'Guardians Collective',
    comingSoon:true,
} as const;